import { Subscriber, SubscriberUnique } from '../internal/Subscriber';
export function createSubscriber(handler, errorHandler, settings) {
  var subscriberSettings = {};
  var errHandler;
  if (errorHandler) {
    if (typeof errorHandler === 'function') {
      errHandler = errorHandler;
      if (settings) {
        subscriberSettings = settings;
      }
    } else {
      subscriberSettings = errorHandler;
    }
  }
  if (subscriberSettings.uniqueEvents) {
    return new SubscriberUnique(handler, errHandler);
  }
  return new Subscriber(handler, errHandler);
}